import React from 'react'
import { IStatus } from './types'
import { Col, Row, Space, Tag, Typography, Timeline } from 'antd'
import { IResourceStatus } from '../../../OrganizationDetails/types'
import { resourceStatusIcons } from '../../../OrganizationDetails/constants'

const Status: React.FC<IStatus> = ({ fileStatus, showTitle = true }) => {
  const { Title } = Typography
  return (
    <Col style={{ padding: '0px 12px' }}>
      <Space direction="vertical" size={'large'}>
        {showTitle && <Title level={5}>Stage Overview:</Title>}
        <Space direction="vertical" size={'large'}>
          <Timeline>
            {fileStatus?.map((stage: IResourceStatus, index) => (
              <Timeline.Item
                key={`${stage.stage} - ${stage.status}`}
                dot={resourceStatusIcons?.[stage.status]}
                style={{ height: 70 }}>
                {stage.stage} - {stage.status}
              </Timeline.Item>
            ))}
          </Timeline>
        </Space>
      </Space>
    </Col>
  )
}

export default Status
